var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes.root,on:{"click":_vm.click}},[_c('img',{staticClass:"wh-full rounded-md",attrs:{"src":_vm.src}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }